// @ts-check
// World units and motion constants live here, independently of rendering pixels.
export const WORLD = Object.freeze({ tile: 32, viewRows: 9, playerWidth: 22, playerHeight: 42, artHeight: 48, levelSpeed: 0.65, fallLimit: -192 });
export const MOTION = Object.freeze({
  walk: 340, sprint: 520, acceleration: 2600, braking: 3600, slideFriction: 760,
  slideThreshold: 120, slideStop: 8, gravity: 2000, jump: 720, doubleJump: 660,
  boostTime: 0.2, poundWindup: 0.11, poundSpeed: 1000, poundGravity: 3600, impactTime: 0.18,
});
export const BOTS = Object.freeze({
  patrolSpeed: 36, gravity: 1800, bounce: 440, coreSpeed: 360, deathTime: 0.24,
  // Simulation ranges use world distance, so resizing cannot change enemy behavior.
  activationAhead: 400, activationBehind: 264, sleepDistance: 856,
});

export const POWER = Object.freeze({ size: 1.45, crouch: 0.65, immunity: 1.6, recoil: 0.18,
  overclockTime: 10, shotSpeed: 480, shotCooldown: 0.28, shotLifetime: 1.3, maxShots: 4,
  pickupSpeed: 55, emergeTime: 0.32 });
